document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('footer-newsletter-form');
  if (!form) return;

  const formMessage = document.getElementById('footer-newsletter-form-message');
  const emailInput = document.getElementById('footer-newsletter-email');
  const phoneInput = document.getElementById('footer-newsletter-phone');
  const consentInput = document.getElementById('footer-newsletter-consent');
  const submitButton = document.getElementById('footer-newsletter-submit');
  const phoneWrapper = document.querySelector('.footer-newsletter__phone-input-wrapper');
  const signupSourceInput = document.getElementById('footer-newsletter-signupSourceID');

  const WEBHOOK_URL = 'https://glamnetic.app.n8n.cloud/webhook/glam-atv';
  const SIGNUP_SOURCE_UK = '1200779';
  const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const USER_MESSAGES = {
    success: 'You’re in! Thanks for joining Glamnetic VIP.',
    alreadySubscribed: 'You’re already subscribed — you’re all set!',
    genericError: 'We couldn’t complete your signup. Please try again.',
    retryError: 'We couldn’t complete your signup. Please try again in a moment.',
    invalidEmail: 'Please enter a valid email address.',
    invalidPhone: 'Please enter a valid UK mobile number.',
    invalidPhoneRegion:
      'That phone number doesn’t look like a valid UK mobile. Please check and try again.',
    checkDetails: 'Please check your email and phone details, then try again.',
  };

  phoneInput?.addEventListener('focus', () => phoneWrapper?.classList.add('focused'));
  phoneInput?.addEventListener('blur', () => {
    if (!phoneInput.value.trim()) {
      phoneWrapper?.classList.remove('focused');
    }
  });

  [emailInput, phoneInput, consentInput].forEach((el) => {
    el?.addEventListener('input', updateSubmitState);
    el?.addEventListener('change', updateSubmitState);
  });

  form.addEventListener('submit', handleSubmit);
  updateSubmitState();

  /**
   * @returns {{ email: string, phone: string, formattedPhone: string|null, consentChecked: boolean, emailValid: boolean, phoneValid: boolean, phoneProvided: boolean }}
   */
  function getFormState() {
    const email = emailInput?.value.trim() || '';
    const phone = phoneInput?.value.trim() || '';
    const consentChecked = Boolean(consentInput?.checked);
    const emailValid = email.length > 0 && EMAIL_PATTERN.test(email);
    const phoneProvided = phone.length > 0;
    const formattedPhone = phoneProvided ? formatPhone(phone) : null;
    const phoneValid = phoneProvided && Boolean(formattedPhone);

    return {
      email,
      phone,
      formattedPhone,
      consentChecked,
      emailValid,
      phoneValid,
      phoneProvided,
    };
  }

  /**
   * Valid combos: email+consent, phone+consent, or email+phone+consent.
   * Any filled field must be valid.
   */
  function isFormReady(state) {
    if (!state.consentChecked) return false;

    const hasValidEmail = state.emailValid;
    const hasValidPhone = state.phoneValid;
    const emailOk = !state.email || state.emailValid;
    const phoneOk = !state.phoneProvided || state.phoneValid;

    if (!emailOk || !phoneOk) return false;
    return hasValidEmail || hasValidPhone;
  }

  function updateSubmitState() {
    if (!submitButton) return;
    submitButton.disabled = !isFormReady(getFormState());
  }

  function handleSubmit(e) {
    e.preventDefault();

    const state = getFormState();
    if (!isFormReady(state)) {
      if (!state.consentChecked) {
        return showMessage(
          'Please tick the box to agree to marketing emails and texts.',
          'error'
        );
      }
      if (!state.email && !state.phoneProvided) {
        return showMessage(
          'Enter a valid email address, a valid UK mobile number, or both.',
          'error'
        );
      }
      if (state.email && !state.emailValid) {
        return showMessage(USER_MESSAGES.invalidEmail, 'error');
      }
      if (state.phoneProvided && !state.phoneValid) {
        return showMessage(USER_MESSAGES.invalidPhone, 'error');
      }
      return showMessage('Please check your details and try again.', 'error');
    }

    const signupSourceID = SIGNUP_SOURCE_UK;
    if (signupSourceInput) signupSourceInput.value = signupSourceID;

    setButtonLoading(true);

    const payload = { signupSourceID };
    if (state.emailValid) payload.email = state.email;
    if (state.formattedPhone) payload.phone = state.formattedPhone;

    fetch(WEBHOOK_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    })
      .then(async (response) => {
        const payload = await parseResponsePayload(response);

        if (response.ok && payload.success !== false) {
          return payload;
        }

        throw new Error(payload.message || USER_MESSAGES.genericError);
      })
      .then((payload) => {
        showMessage(payload.message || USER_MESSAGES.success, 'success');
        form.reset();
        phoneWrapper?.classList.remove('focused');
        updateSubmitState();
      })
      .catch((error) => {
        console.error('Subscription error:', error);
        showMessage(toSafeErrorMessage(error), 'error');
      })
      .finally(() => setButtonLoading(false));
  }

  /**
   * @param {Response} response
   * @returns {Promise<{ success?: boolean, message?: string }>}
   */
  async function parseResponsePayload(response) {
    const contentType = response.headers.get('content-type') || '';
    const raw = await response.text();
    const ok = response.ok;

    if (!raw) {
      return {
        success: ok,
        message: mapWebhookMessage('', ok, ''),
      };
    }

    if (isLikelyHtml(raw)) {
      return {
        success: false,
        message: USER_MESSAGES.retryError,
      };
    }

    if (
      contentType.includes('application/json') ||
      raw.trim().startsWith('{') ||
      raw.trim().startsWith('[')
    ) {
      try {
        const data = JSON.parse(raw);
        const record = Array.isArray(data) && data[0] ? data[0] : data;
        return normalizePayload(record, ok, raw);
      } catch (err) {
        console.error('Failed to parse webhook JSON:', err);
      }
    }

    return {
      success: ok,
      message: mapWebhookMessage('', ok, raw),
    };
  }

  /**
   * @param {object} data
   * @param {boolean} ok
   * @param {string} raw
   */
  function normalizePayload(data, ok, raw) {
    const apiMessage = typeof data?.message === 'string' ? data.message : '';
    const success = Boolean(ok && data && data.success !== false);

    return {
      success,
      message: mapWebhookMessage(apiMessage, success, raw),
    };
  }

  /**
   * @param {string} apiMessage
   * @param {boolean} success
   * @param {string} raw
   */
  function mapWebhookMessage(apiMessage, success, raw) {
    if (success || /^subscribed$/i.test(apiMessage.trim())) {
      return USER_MESSAGES.success;
    }

    const text = `${apiMessage} ${raw || ''}`.trim();

    if (isLikelyHtml(text) || /bad gateway|\b502\b/i.test(text)) {
      return USER_MESSAGES.retryError;
    }

    if (/signupSourceID|unknown or missing/i.test(apiMessage)) {
      return USER_MESSAGES.genericError;
    }
    if (text.includes('PHONE_INVALID_NUMBER_FOR_REGION')) {
      return USER_MESSAGES.invalidPhoneRegion;
    }
    if (text.includes('phone field') && text.includes('is not valid')) {
      return USER_MESSAGES.invalidPhone;
    }
    if (text.includes('Invalid destination value') && text.includes('phone')) {
      return USER_MESSAGES.invalidPhone;
    }
    if (/already subscribed|already exists/i.test(text)) {
      return USER_MESSAGES.alreadySubscribed;
    }
    if (/\bemail\b/i.test(text) && /invalid|not valid/i.test(text)) {
      return USER_MESSAGES.invalidEmail;
    }
    if (text.includes('Bad request')) {
      return USER_MESSAGES.checkDetails;
    }

    return USER_MESSAGES.retryError;
  }

  /**
   * @param {string} text
   */
  function isLikelyHtml(text) {
    return /<!DOCTYPE html|<html[\s>]/i.test(text || '');
  }

  /**
   * @param {unknown} error
   */
  function toSafeErrorMessage(error) {
    const message = error instanceof Error ? error.message : '';
    const knownMessages = Object.values(USER_MESSAGES);

    if (knownMessages.includes(message)) return message;
    return USER_MESSAGES.genericError;
  }

  /**
   * @param {string} phone
   * @returns {string|null}
   */
  function formatPhone(phone) {
    if (!phone) return null;

    const digits = phone.replace(/\D/g, '');
    if (!digits) return null;

    let formatted;
    if (digits.length === 10) {
      formatted = '+44' + digits;
    } else if (digits.length === 11 && digits.startsWith('44')) {
      formatted = '+' + digits;
    } else if (digits.length === 11 && digits.startsWith('0')) {
      formatted = '+44' + digits.substring(1);
    } else if (digits.length === 12 && digits.startsWith('44')) {
      formatted = '+' + digits;
    } else {
      formatted = '+44' + digits;
    }

    return /^\+44\d{10}$/.test(formatted) ? formatted : null;
  }

  /**
   * @param {boolean} isLoading
   */
  function setButtonLoading(isLoading) {
    if (!submitButton) return;

    const svg = submitButton.querySelector('svg');
    const svgHTML = svg ? svg.outerHTML : '';

    if (isLoading) {
      submitButton.disabled = true;
      submitButton.innerHTML = 'Joining...' + (svgHTML ? ' ' + svgHTML : '');
      return;
    }

    submitButton.innerHTML = 'Join Us' + (svgHTML ? ' ' + svgHTML : '');
    updateSubmitState();
  }

  /**
   * @param {string} message
   * @param {'success'|'error'} type
   */
  function showMessage(message, type) {
    if (!formMessage) return;

    formMessage.replaceChildren();
    const messageEl = document.createElement('div');
    messageEl.className = `footer-newsletter__${type}-message`;
    messageEl.textContent = message;
    formMessage.appendChild(messageEl);
    formMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

    window.clearTimeout(showMessage._timeoutId);
    showMessage._timeoutId = window.setTimeout(() => {
      const messageEl = formMessage.querySelector(
        `.footer-newsletter__${type}-message`
      );
      if (!messageEl) return;

      messageEl.style.opacity = '0';
      window.setTimeout(() => {
        if (formMessage.contains(messageEl)) {
          messageEl.remove();
        }
      }, 500);
    }, 6000);
  }
});
